<template>
    <footer class="footer-area">
        <div class="footer-wave"></div>
        <div class="container">
            <div class="row">
                <div class="col">
                    <Subscribe/>
                </div>
            </div>
            <div class="row footer-main-content-area">
                <div class="col-xl-3 col-lg-3 col-md-3 footer-logo">
                    <figure>
                        <router-link to="/">
                            <img src="../../public/img/logo.png" :alt="siteTitle">
                        </router-link>
                    </figure>
                    <p>{{siteAddress}}
                        <a :href="`tel:${sitePhone}`"><i class="fas fa-phone-alt"></i>{{ sitePhone }}</a>
                    </p>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 footer-widget">
                    <h4>Services</h4>
                    <ServiceLists :services="allServices" className="footer-links-list" module="services" icon="false" />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 footer-widget">
                    <h4>Company</h4>
                    <ul class="footer-links-list">
                        <li v-for="(data, index) of company" :key="index">
                            <router-link :to="data.path">{{ data.name }}</router-link>
                        </li>   
                    </ul>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 footer-widget">
                    <h4>Legals</h4>
                    <ul class="footer-links-list">
                        <li v-for="(data, index) of legals" :key="index">
                            <router-link :to="data.path">{{ data.name }}</router-link>
                        </li>                        
                    </ul>
                    <a href="//www.dmca.com/Protection/Status.aspx?ID=5b21ddb4-8fed-46a3-a6f9-23571a7ef05b" title="DMCA.com Protection Status" class="dmca-badge" target="_blank" rel="noopener noreferrer"> <img src ="https://images.dmca.com/Badges/DMCA_logo-grn-btn150w.png?ID=5b21ddb4-8fed-46a3-a6f9-23571a7ef05b"  alt="DMCA.com Protection Status" /></a>  
                </div>
            </div>
            <div class="row copyright-are">
                <div class="col-12">
                    <div class="copyright-text text-center">
                        <p>{{ copyrightDate }} &copy; All rights reserved by
                            <router-link to="/">{{ siteTitle }}</router-link>
                        </p>

                        <SocialShare />
                    </div>
                </div>
            </div>
        </div>

        <!-- Effect Start-->
        <img class="bubble slow" src="../../public/img/all-effect-img/Top_bubble.svg" id="pink-side-bubble-111" alt="b">
        <img class="bubble" src="../../public/img/all-effect-img/Bottom_Bubble.svg" id="pink-side-bubble-222" alt="b">
        <img class="bubble slow" src="../../public/img/all-effect-img/Bog-Blob.svg" id="blue-side-bubble-111" alt="b">
        <!-- Effect End-->
         <!--Go To Top Arrow area start-->
        <div class="top-arrow">
            <a href="#" id="scroll" style="display: none;" @click.prevent="scrolltoTopEl"><i class="fas fa-angle-up"></i></a>
        </div>
        <!--Go To Top Arrow area End-->
    </footer>
</template>

<script>
import Subscribe from "./Contact/Subscribe";
import ServiceLists from './Service/ServiceList'
import SocialShare from './SocialShare'

export default {
    components: {Subscribe, ServiceLists, SocialShare},
    data(){
        return {
            sitePhone: '',
            siteAddress: '',
            siteTitle: '',
            copyrightDate: new Date().getFullYear(),
            allServices:[],
            legals: [
                {name: 'Terms And Conditions', path:'/terms-conditions'},
                {name: 'Privacy Policy', path:'/privacy-policy'},
                {name: 'FAQ', path:'/faq'}
            ],
            company: [
                {name: 'About Us', path:'/about-us'},
                {name: 'Contact Us', path:'/contact-us'},
                // {name: 'My Account', path:'/dashboard'}
            ]
        }
    },
    methods: {
        toggleScrollTop(){
            if(document.documentElement.scrollTop >= 300)
                document.querySelector('a#scroll').style.display = 'block'
            else
                document.querySelector('a#scroll').style.display = 'none'
        },
        scrolltoTopEl(){
            window.scrollTo({top: 0, behavior: 'smooth'});
        },
        async getData(){
            let params = {
                limit: this.limit
            }
            this.$http.get(`/services`, { params }).then(res=>{                
                if(res.status === 200 && res.data.result){
                    this.allServices = res.data.result
                }
            })
        }
    },
    created: function(){
        window.addEventListener('scroll', this.toggleScrollTop); 
        this.getData()
    },
    watch: {
        "$store.state.site.sitePhone"(){
            this.sitePhone = this.$store.state.site.sitePhone
            this.siteTitle = this.$store.state.site.siteTitle
            this.siteAddress = this.$store.state.site.siteAddress
        }
    }
}
</script>

